/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileStatusEnum } from './FileStatusEnum';
import {
    FileStatusEnumFromJSON,
    FileStatusEnumFromJSONTyped,
    FileStatusEnumToJSON,
    FileStatusEnumToJSONTyped,
} from './FileStatusEnum';

/**
 * Serializer for the EventAttachment model.
 * @export
 * @interface EventFileCreateRequest
 */
export interface EventFileCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof EventFileCreateRequest
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreateRequest
     */
    event: string;
    /**
     * 
     * @type {number}
     * @memberof EventFileCreateRequest
     */
    uploadedBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreateRequest
     */
    file: string;
    /**
     * 
     * @type {FileStatusEnum}
     * @memberof EventFileCreateRequest
     */
    fileStatus?: FileStatusEnum;
}



/**
 * Check if a given object implements the EventFileCreateRequest interface.
 */
export function instanceOfEventFileCreateRequest(value: object): value is EventFileCreateRequest {
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    return true;
}

export function EventFileCreateRequestFromJSON(json: any): EventFileCreateRequest {
    return EventFileCreateRequestFromJSONTyped(json, false);
}

export function EventFileCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFileCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'event': json['event'],
        'uploadedBy': json['uploaded_by'] === undefined ? undefined : json['uploaded_by'] === null ? null : json['uploaded_by'],
        'description': json['description'] == null ? undefined : json['description'],
        'file': json['file'],
        'fileStatus': json['file_status'] == null ? undefined : FileStatusEnumFromJSON(json['file_status']),
    };
}

export function EventFileCreateRequestToJSON(json: any): EventFileCreateRequest {
    return EventFileCreateRequestToJSONTyped(json, false);
}

export function EventFileCreateRequestToJSONTyped(value?: EventFileCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'event': value['event'],
        'uploaded_by': value['uploadedBy'],
        'description': value['description'],
        'file': value['file'],
        'file_status': FileStatusEnumToJSON(value['fileStatus']),
    };
}

